import { ChargeBeePlanId } from '@prerender/billing-shared';

function isCacheSettingsAllowedByPlan(planId: ChargeBeePlanId): boolean {
  return (
    planId === ChargeBeePlanId.Pro ||
    planId === ChargeBeePlanId.EnterprisePlus ||
    planId === ChargeBeePlanId.EnterprisePlusYearly ||
    planId === ChargeBeePlanId.CustomEnterprise3Years
  );
}

export default isCacheSettingsAllowedByPlan;
